<section class="margem-top container">
  <h5>Comunicação Eletrônica</h5>
  <div *ngFor="let comunicado of comunicados; let index = index">
    <div class="br-table">
      <div class="table-header dataDscAssunto">
        <div class="top-bar">
          <div class="table-title">{{ comunicado.dscAssunto }}</div>
        </div>
        <div>
          <p class="dataDscAssunto_dataHora">{{ comunicado.datCaixaPostal | date: 'dd/MM/yyyy HH:mm'}} </p>
        </div>
      </div>
      <div class="responder">
        <div>
          <p class="destinatarioRemetente">De: {{ comunicado.remetenteComunicado.nome }}</p>
          <p class="destinatarioRemetente">Para: {{ comunicado.numOrigem == 1 ? comunicados[0].remetenteComunicado.nome : comunicado.destinatarioComunicado.nome }}</p>
        </div>
        <div class="responder__resposta-comunicado">
          <div class="responder__numero-comunicado">
            <img class="carimbo" src="../../../assets/images/icones/stamp.svg" alt="Carimbo"><p>{{ comunicado.seqCaixaPostal }}</p>
          </div>
          <div class="top-bar">
            <button 
              (click)="permitirRespostaToggle()" 
              class="responder__botao" 
              *ngIf="comunicado?.tipoComunicado?.numResposta && !responder && index == 0">
              Responder</button>
            <button (click)="abrirNomearResponsavel()" class="responder__botao" *ngIf="comunicado.tipoComunicado.numNomeado && index == 0"> Nomear/Remover Responsável</button>
            <button class="responder__botao btnHistorico" (click)="visualizarHistorico()"  *ngIf="index == 0">
              Cópia de Inteiro Teor
              <span>
                <img class="iconeDownload" src="../../../../assets/images/icones/download.svg" alt="Ýcone de download">
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="top-bar"  [ngClass]="{'divisoria': !comunicado.temAnexo}">
        <app-comunicado [htmlComunicado]="comunicado.txtMensagem"></app-comunicado>
      </div>
      <div *ngIf="responder && index == 0">
        <div class="top-bar">
          <div class="br-textarea">
            <textarea class="textarea" rows="5" cols="88" [(ngModel)]="respostaComunicado" placeholder="Digite aqui sua resposta..."></textarea>
            <p class="mensagem-alerta" *ngIf="respostaComunicado.length < 10 && respostaComunicado.length > 0">Obrigatório no mínimo 10 dígitos no corpo da mensagem</p>
          </div>
        </div>
        <div>
          <div class="top-bar">
            <label for="file-input" class="responder__botao-anexo">Anexo
              <img class="responder__icone" src="../../../../assets/images/icones/paper-clip.svg" alt="Ýcone de inserir anexo.">
            </label>
            <input id="file-input" type="file" accept="application/pdf" multiple="multiple" (change)="anexo($event)" #fileUpload>
            <div class="anexos__enviar-margem">
              <button class="botao-modoEscuro anexos__fechar" (click)="fechar()">Fechar</button>
              <button (click)="responderComunicado()" class="botao-modoEscuro anexos__enviar" [disabled]="respostaComunicado.length < 10">Enviar</button>
            </div>
          </div>
          <div class="ml-4" >
            <span *ngIf="files.length == 0">Tamanho máximo do(s) arquivo(s): <b>1GB</b></span>  
          </div>
          <div class="file-upload ml-4 mt-2">
            <div *ngFor="let item of files; let i = index" style="margin-bottom: 12px; padding: 10px; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; justify-content: space-between;">
              <div style="flex: 1; display: flex; align-items: center; gap: 10px;">
                <span style="flex: 1;">{{ item.name }}</span>
                <span *ngIf="arquivosSalvando.has(item.name)" style="color: #1351b4; font-size: 0.9em; white-space: nowrap;">Salvando rascunho...</span>
                <span *ngIf="arquivosDraft.has(item.name) && !arquivosSalvando.has(item.name)" style="color: green; font-size: 0.9em; white-space: nowrap;">✓ Rascunho salvo</span>
              </div>
              <fa-icon class="lixeira" [icon]="['fas', 'trash']" (click)="deletarArquivo(i)" style="cursor: pointer; margin-left: 15px; color: #d32f2f;"></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anexos divisoria" *ngIf="comunicado.temAnexo">
      <p class="anexos__titulo">
        Anexos ({{ comunicado.anexos.length }})
      </p>
      <div class="anexos__container-botao">
        <button *ngFor="let anexo of comunicado.anexos"
          class="anexos__botao anexos__botao-display"
          [title]="anexo.dscNomeAnexo"
          (click)="downloadAnexo(anexo)"
        >
        <span class="anexos__nomeAnexo">{{ anexo.dscNomeAnexo }}</span>
        <span>
          <img class="anexos__icone" src="../../../../assets/images/icones/download.svg" alt="Ýcone de download">
        </span>
        </button>
      </div>
      <div>
    </div>
  </div>
</div>
<div class="div-botao">
  <button class="br-button secondary mt-5 mr-4 anexos__botao-retorno" type="button" routerLink="/caixa-postal">Retornar</button>
</div>
</section>

<div class="backdrop" *ngIf="modalNomearResponsavel">
  <div class="div br-modal x-large position-modal">
    <div class="row">
      <div class="ml-5 br-modal-header col-10">Nomear responsável por atender a demanda do comunicado em destaque</div>
      <button class="ml-5 close-button col-1" (click)="fecharNomearResponsavel()" aria-label="Fechar">        
        &times;
      </button>
    </div>

    <div class="br-modal-body overflow">
      <div class="br-table col-12 mt-4">
        <table>
          <thead>
            <tr>
              <th scope="col">C.P.F</th>
              <th scope="col">Nome</th>
              <th scope="col">Data Nomeação</th>
              <th scope="col">Data Remoção</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="listaNomeacoes.length > 0; else semDados"></ng-container>
            <tr *ngFor="let item of listaNomeacoes" class="cursor">
              <td>{{ item.dscCpfCnpj | mask: 'CPF_CNPJ' }}</td>
              <td>{{ item.nomeCadastro }}</td>
              <td>{{ item.dataNomeacao | date: 'dd/MM/yyyy' }}</td>
              <td>{{ item.dataRemocao ? (item.dataRemocao | date: 'dd/MM/yyyy') : '-' }}</td>
              <td>
                <button class="br-button botao-modal" (click)="removerNomeacao(item)" title="Remover a nomeação" [disabled]="item.dataRemocao !== null">
                  <img
                  class="iconeRemoverNomeacao"
                  [src]="modoEscuro ? '../../../assets/images/icones/white-thumbs-down-regular.svg' : '../../../assets/images/icones/thumbs-down-regular.svg'"
                  alt="Remover a nomeação">
                </button>
              </td>
            </tr>
            <ng-template #semDados>
              <tr>
                <td colspan="7" align="center">Sem dados para serem exibidos.</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="mt-4 d-flex justify-content-center">
        <button [disabled]="botaoDesabilitado" class="botao-modoEscuro br-button danger" (click)="fecharNomearResponsavel()">Desistir de Nomear</button>
        <button [disabled]="botaoDesabilitado" class="botao-modoEscuro br-button primary ml-4" (click)="exibirFormNomear()" >Adicionar Responsável</button>
      </div>
    </div>
    <div class="br-modal-footer justify-content-center">
    </div>
  </div>
</div>

<div class="backdrop" *ngIf="exibirCamposNomear">
  <div class="div br-modal x-large position-modal">
    <div class="row">
      <div class="ml-5 br-modal-header col-10">Nomear responsável por atender a demanda do comunicado em destaque</div>
      <button class="ml-5 close-button col-1" (click)="fecharFormNomear()" aria-label="Fechar">        
        &times;
      </button>
    </div>
    <div class="br-modal-body overflow">
      <div *ngIf="exibirCamposNomear" class="row mt-4">
        <div class="br-input col-4">
          <label id="cpf">C.P.F</label>
          <input
            type="text"
            name="cpf"
            id="cpf"
            [(ngModel)]="cpfNomear"
            placeholder="C.P.F"
            maxlength="14"
            mask="CPF_CNPJ"
            (blur)="validarCpf()"
          />
          <button class="br-button" type="button" (click)="validarCpf()">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </button>
        </div>
        <div class="br-input col-8">
          <label id="nome">Nome</label>
          <input
            type="text"
            name="nome"
            id="nome"
            placeholder="Nome"
            [(ngModel)]="nomeNomear"
            disabled
          />
        </div>

        <div class="br-input col-6 mt-4">
          <label for="selectTipoGed">Tipo de Documento</label>
          <select
              id="selectTipoGed"
              class="form-control mt-2"
              [(ngModel)]="selectedTipoGed"
              name="selectTipoGed"
              (change)="onTipoGedChange()"
          >
            <option [ngValue]="null" disabled>Selecione uma opção…</option>
            <option *ngFor="let t of tipoGedOptions" [ngValue]="t">
                {{ t.nome }}
            </option>
          </select>
        </div>

        <div class="br-input col-4 mt-4" *ngIf="selectedTipoGed">
            <label for="numeroDocumento">Número do Documento</label>
            <input
              id="numeroDocumento"
              class="form-control form-control-sm"
              type="text"
              [(ngModel)]="numeroDocumento"
              name="numeroDocumento"
              placeholder="Digite o número do documento"
              maxlength="60"
              (input)="numeros($event)"
              (blur)="numeroDocumentoTouched = true"
            />
            <p class="mensagem-alerta"
              *ngIf="numeroDocumentoTouched && !numeroDocumento">
              O campo é obrigatório.
            </p>
        </div>

          <div class="mt-4 br-input col-8" *ngIf="selectedTipoGed">
            <div class="br-upload">
              <label class="upload-label">
                Adicionar Documento – {{ selectedTipoGed.nome }}
              </label>
              <input
                class="upload-input"
                type="file"
                accept="application/pdf"
                #file_input
                (change)="onFileSelected($event)"
              />
              <button class="upload-button" type="button" (click)="file_input.click()">
                <fa-icon [icon]="['fas','upload']"></fa-icon>
                <span>Selecione o arquivo</span>
              </button>
              <div class="upload-list mt-2 file-name">
                  <div *ngIf="selectedFile" class="mt-2">
                  <span>Arquivo Selecionado: </span>
                  <span class="negrito">{{ selectedFileName }}</span>
                  <fa-icon
                    class="lixeira"
                    [icon]="['fas','trash']"
                    *ngIf="selectedFile"
                    (click)="removeSelectedFile()"
                  ></fa-icon>
                </div>  
              </div>
              <span *ngIf="!selectedFile">Tamanho máximo do arquivo: <b>20MB</b></span>  
            </div>
          </div>
          
        <div class="mt-4 botoesNomear">
          <button class="botao-modoEscuro br-button danger" (click)="fecharFormNomear()">Desistir</button>
          <button
            class="botao-modoEscuro br-button primary ml-4 mr-4"
            (click)="nomearResponsavel()"
            [disabled]="this.numeroDocumento == '' || this.cpfNomear == '' || this.cpfNomear.length < 11 || this.nomeNomear == ''"
          >Nomear</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="backdrop" *ngIf="modalHistorico">
  <div class="div br-modal x-large position-modal-historico">
    <div class="br-modal-header">Visualizar Cópia de Inteiro Teor</div>
    <div class="br-modal-body overflow">
      <div class="d-flex justify-content-center mb-2">
        <button class="botao-modoEscuro br-button danger" (click)="modalHistorico=false">Fechar</button>
        <button class="botao-modoEscuro br-button primary ml-4" (click)="baixarHistorico()">Baixar Cópia de Inteiro Teor</button>
      </div>
      <pdf-viewer
        [src]="src"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="0.8"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="true"
        style="width: 100%; height: 600px"
        (after-load-complete)="pdfCarregado()"
      >
      </pdf-viewer>
    </div>
  </div>
</div>


<div class="carregamento" *ngIf="loading">
  <img src="../../../assets/images/icones/logo-animado.svg">
</div>
